import Target from './target'

export default class Notification {
  readonly id: number
  readonly targetType: string
  readonly targetId: string
  readonly action: string
  readonly unread: boolean
  readonly target: Target
  readonly message: string
  readonly url: string

  constructor(data: { [key: string]: any }) {
    this.id = data.id
    this.targetType = data.targetType
    this.targetId = data.targetId
    this.action = data.action
    this.unread = data.unread
    this.message = data.message
    this.url = data.url

    if (data.target) {
      this.target = new Target(data.target)
    }
  }
}
